<!-- Responsibility: Display basic admin access details and status.
Scope: View-only card for admin access state. -->
<admin-access-card>
  <section class="admin-card">
    <header>
      <h2>Access</h2>
      <button type="button" class="action-btn subtle" onclick={ props.onRefresh }>REFRESH</button>
    </header>
    <p class="admin-copy">Live admin state resolves from Firestore when available, with local fallback for offline/dev operation.</p>
    <ul class="admin-list">
      <li><strong>Status</strong><span>{ props.statusLabel }</span></li>
      <li><strong>Role</strong><span>{ props.roleLabel }</span></li>
      <li><strong>UID</strong><span>{ props.uid || 'none' }</span></li>
      <li><strong>Email</strong><span>{ props.email || 'none' }</span></li>
      <li><strong>Config Source</strong><span>{ props.sourceLabel }</span></li>
      <li><strong>Flags Saved</strong><span>{ props.flagsSavedLabel }</span></li>
    </ul>
    <p class="admin-note">Supreme admin email: { props.supremeEmail }</p>
    <p if={ props.accessError } class="admin-error">{ props.accessError }</p>
    <p if={ props.saveMessage } class="admin-note">{ props.saveMessage }</p>
  </section>

  <style>
    .admin-card {
      display: grid;
      gap: var(--space-sm);
      border: 1px solid color-mix(in srgb, var(--border) 46%, transparent);
      border-radius: 1rem;
      padding: var(--space-md);
      background:
        linear-gradient(180deg, color-mix(in srgb, var(--surface-raised) 88%, transparent), color-mix(in srgb, var(--bg) 88%, transparent)),
        radial-gradient(circle at top right, color-mix(in srgb, var(--gold) 14%, transparent), transparent 58%);
      box-shadow: var(--shadow-elev-2);
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: var(--space-sm);
    }

    h2 {
      margin: 0;
      color: var(--text-prose);
    }

    .admin-copy,
    .admin-note {
      color: var(--text-muted);
      font-size: var(--type-sm, 0.875rem);
      line-height: 1.6;
      margin: 0;
    }

    .admin-error {
      color: color-mix(in srgb, var(--danger) 82%, white);
      margin: 0;
    }

    .admin-list {
      display: grid;
      gap: var(--space-xs);
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .admin-list li {
      display: flex;
      justify-content: space-between;
      gap: var(--space-sm);
      padding-bottom: var(--space-xs);
      border-bottom: 1px solid color-mix(in srgb, var(--border) 28%, transparent);
    }

    .admin-list li span {
      text-align: right;
      color: var(--text-prose);
    }
  </style>
</admin-access-card>
